import { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const WellnessReminder = () => {
  const [reminders, setReminders] = useState([
    { id: "1", text: "Take a 5-minute break", time: "10:00" },
    { id: "2", text: "Drink a glass of water", time: "14:00" },
  ]);
  const [newReminder, setNewReminder] = useState({ text: "", time: "" });

  const addReminder = () => {
    if (newReminder.text && newReminder.time) {
      setReminders([...reminders, { ...newReminder, id: Date.now().toString() }]);
      setNewReminder({ text: "", time: "" });
    }
  };

  const removeReminder = (id: any) => {
    setReminders(reminders.filter((reminder) => reminder.id !== id));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Wellness Reminders</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 mb-4">
          <Input
            placeholder="Reminder text"
            value={newReminder.text}
            onChange={(e: any) =>
              setNewReminder({ ...newReminder, text: e?.target?.value })
            }
          />
          <Input
            type="time"
            value={newReminder.time}
            onChange={(e: any) =>
              setNewReminder({ ...newReminder, time: e?.target?.value })
            }
          />
          <Button onClick={addReminder} className="w-full">
            <Plus className="mr-2 h-4 w-4" /> Add Reminder
          </Button>
        </div>
        <AnimatePresence>
          {reminders?.map((reminder) => (
            <motion.div
              key={reminder.id}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="flex justify-between items-center text-xs p-2 bg-secondary rounded-md mb-2"
            >
              <span>
                {reminder.text} - {reminder.time}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => removeReminder(reminder.id)}
              >
                <X className="h-4 w-4" />
              </Button>
            </motion.div>
          ))}
        </AnimatePresence>
      </CardContent>
    </Card>
  );
};

export default WellnessReminder;
